export const POSITION = {
    DEFAULT: 'default',
    REVERSE: 'reverse'
};